<template>
  <div class="user-manage">
    <div class="heaer-text">用户报表</div>
    <div style="overflow: hidden">
      <HeaderFilter @listenerIsRate="listenerIsRate" @downloadFile="downloadFile" @showLoading="showLoading" @changeHeader="changeHeader" />
    </div>
    <UserTable
      :productList="productList"
      :column="column"
      ref="usertable"
      :loading="loading"
      :isisRateProps="isisRate"
      :totalColumn="totalColumn"
      @computTotalColumn="computTotalColumn"
    />
  </div>
</template>
<script>
import HeaderFilter from "./userheaderFilter";
import UserTable from "./userTable";
import {
  product_table_column_shu,
  product_table_column_lv,
  product_table_column_lv_geo,
  product_table_column_shu_geo,
} from "../../config/table_comlun";
export default {
  data() {
    return {
      isisRate: true,
      loading: true,
      country: "1",
      totalColumn: [],
    };
  },
  name: "usermanage",
  computed: {
    column: function () {
      return this.isisRate
        ? this.country == "2"
          ? product_table_column_lv_geo
          : product_table_column_lv
        : this.country == "2"
        ? product_table_column_shu_geo
        : product_table_column_shu;
    },
    productList: function () {
      return this.$store.state.UserManage.purByCountryList;
    },
  },
  // mounted() {
  //   let param = {
  //     order: "asc",
  //     offset: 0
  //   };
  //   this.$store.dispatch("getProductTableList", {
  //     param,
  //     cb: () => {}
  //   });
  // },
  methods: {
    listenerIsRate: function (param) {
      this.isisRate = param;
      this.loading = false;
    },
    showLoading: function () {
      this.loading = true;
    },
    downloadFile() {
      this.$refs.usertable.downLoadFileToExcel();
    },
    changeHeader(country) {
      this.country = country;
      this.$refs.usertable.refresh();
    },
    computTotalColumn(arr) {
      this.totalColumn = arr;
    },
    // changeAFIDFilter(val) {}
  },
  components: {
    HeaderFilter,
    UserTable,
  },
};
</script>

<style scoped>
.user-manage {
  padding-bottom: 60px;
}
.heaer-text {
  padding: 16px 16px 6px 16px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}
</style>
